<template>
  <div class="alert alert-warning d-flex flex-wrap align-items-center gap-3 py-3 mb-0">
    <i class="bi bi-exclamation-triangle fs-2 text-warning"></i>
    <div class="flex-grow-1">{{ message }}</div>
    <div class="d-flex gap-2">
      <!-- nouvel onglet : on ne perd pas la page en cours -->
      <a :href="subscriptionHref" target="_blank" rel="noopener" class="btn btn-sm btn-warning text-nowrap">
        {{ $t('subscription.my_subscription') }}
      </a>
      <button type="button" class="btn btn-sm btn-light-warning text-nowrap" @click="contact">
        <i class="bi bi-chat-dots me-1"></i>{{ $t('limit_banner.contact') }}
      </button>
      <button type="button" class="btn btn-sm btn-icon btn-active-light-warning" :aria-label="$t('button.close')" @click="$emit('close')">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    <CreateTicketModal ref="ticket" modal-id="limitTicketModal" />
  </div>
</template>

<script>
import CreateTicketModal from '@/components/support/CreateTicketModal.vue'

/**
 * Limite de l'abonnement atteinte : affiché au clic sur un bouton grisé (ajout d'utilisateur, de
 * boutique…). « Nous contacter » ouvre un ticket de support pré-rempli (facturation), traité
 * dans le Landlord.
 */
export default {
  name: 'LimitReachedBanner',
  components: { CreateTicketModal },
  props: {
    message: { type: String, required: true },
    // message pré-rempli du ticket « Nous contacter » (par défaut : le message du bandeau)
    ticketMessage: { type: String, default: '' },
  },
  emits: ['close'],

  computed: {
    subscriptionHref() {
      return this.$router.resolve({ name: 'subscription-plans' }).href
    },
  },

  methods: {
    contact() {
      const escape = text => String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      this.$refs.ticket.open({
        category: 'billing',
        message: `<p>${escape(this.ticketMessage || this.message)}</p>`,
      })
    },
  },
}
</script>
